import { axiosInstance } from "./axiosInstance";

function getSuggestedPeople(data) {
  return axiosInstance.get(`suggested-people?account_type=${data}`);
}

function getPosts({ post_id, ...params }) {
  return axiosInstance.get(post_id ? `posts/${post_id}` : "posts", { params });
}

function getSummaryPosts({ post_id, ...params }) {
  return axiosInstance.get("posts/search-by-date", { params });
}

function getPost({ account_type, post_id }) {
  return axiosInstance.get(`single-post/${post_id}?account_type=${account_type}`);
}

function addPost(data) {
  return axiosInstance.post("posts/add", data);
}

function editPost(id, data) {
  return axiosInstance.put(`posts/${id}`, data);
}

function getMarketingData() {
    return axiosInstance.get('city/marketing_data');
}

function deletePost(id) {
  return axiosInstance.delete(`posts/${id}`);
}

function searchPosts(params) {
  return axiosInstance.get("posts/search", { params });
}

function likePost({ isLiked, ...data }) {
  return axiosInstance.put(`posts/${isLiked ? "like" : "unlike"}`, data);
}

function addComment(data) {
  return axiosInstance.post("comments/add", data);
}

function editComment(data) {
  return axiosInstance.put(`comments/edit`, data);
}

function likeComment(data) {
  return axiosInstance.post("comments/like", data);
}
function unlikeComment(data) {
  return axiosInstance.post("comments/unlike", data);
}
function likeReply(data) {
  return axiosInstance.post("replies/like", data);
}
function unlikeReply(data) {
  return axiosInstance.post("replies/unlike", data);
}

function addReply(data) {
  return axiosInstance.post("replies/add", data);
}

function editReply(data) {
  return axiosInstance.put(`replies/edit`, data);
}


function getRepliesOfComment(data) {
  return axiosInstance.get(`replies/${data}`);
}
function updateCurrentStatus(data) {
  return axiosInstance.patch("current-status", data);
}

const updateNetworkingStatus = (data, account_type) => {
  return axiosInstance.post('current-status/open-networking', {open_networking: data, networking_type: "", account_type});
}

function getInvitationLink() {
  return axiosInstance.get("invitations/generate-link");
}

function getInvitations() {
  return axiosInstance.get("invitations/get-invited_users");
}

function getNotificationSetting() {
  return axiosInstance.get("notifications/get-user-settings");
}

// Notifications follow the profile being viewed: an account creator's
// organization alerts are left out while they view their personal profile
// ("user", set by Switch to User Profile).
const notificationView = () => ({
  account_type: localStorage.getItem("account_type") || undefined,
});

function getNotificationList(data) {
  return axiosInstance.get("notifications", {
    params: {
      ...data,
      ...notificationView(),
    },
  });
}

function updateNotificationSetting(data) {
  return axiosInstance.put(`notifications/user-settings`, data);
}

function getUnReadNotificationCount() {
  return axiosInstance.get("/notifications/unseen-count", {
    params: notificationView(),
  });
}

function updateNotificationReadStatus() {
  return axiosInstance.put("notifications/mark-all-seen", null, {
    params: notificationView(),
  });
}

function updateSingleNotificationReadStatus(id) {
  return axiosInstance.put(`notifications/${id}/mark-one-seen`);
}

const sendChatNotification = (data) => {
  return axiosInstance.post('send-chat-notification', data);
}



export {
  getSuggestedPeople,
  getPosts,
  getSummaryPosts,
  searchPosts,
  addPost,
  likePost,
  addComment,
  updateCurrentStatus,
  getMarketingData,
  getInvitationLink,
  getInvitations,
  updateNotificationSetting,
  getNotificationSetting,
  getUnReadNotificationCount,
  updateNotificationReadStatus,
  getNotificationList,
  getPost,
  updateSingleNotificationReadStatus,
  updateNetworkingStatus,
  deletePost,
  editPost,
  addReply,
  getRepliesOfComment,
  likeComment,
  unlikeComment,
  likeReply,
  unlikeReply,
  editComment,
  editReply,
  sendChatNotification
};
